module.exports = __webpack_public_path__ + "media/img/logo-transparent-sm-dark-bare-e74921868eae554b927f7e2e8c77a3b6.png";